import { useState } from "react";
import { api, money, pct } from "../../lib/api";
import { act, Card, H1, abtn, ainput } from "../../components/admin/ui";

export default function Pricing() {
  const [f, setF] = useState({ supplier_cost: 17, shipping_cost: 0, inbound: 0, market: "CA", markup: "", ad_cost: "" });
  const [r, setR] = useState(null);
  const run = async () => {
    const body = { ...f, supplier_cost: +f.supplier_cost, shipping_cost: +f.shipping_cost, inbound: +f.inbound, markup: f.markup === "" ? null : +f.markup, ad_cost: f.ad_cost === "" ? null : +f.ad_cost };
    setR(await act(() => api.post("/admin/pricing/simulate", body)));
  };
  const inp = (k, l) => <label key={k} className="block"><span className="label-xs">{l}</span><input data-testid={`pricing-${k}`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${ainput} w-full mt-1`} /></label>;
  return (
    <div>
      <H1 sub="Prix minimum = (frais fixes + coût pub + coût rendu) / (1 − frais variables − marge contributive cible). La majoration sur coût n'est pas la marge sur prix de vente.">Moteur de prix</H1>
      <div className="grid lg:grid-cols-[360px_1fr] gap-4">
        <Card title="Simulation">
          <div className="space-y-3">
            {inp("supplier_cost", "Coût fournisseur (€)")}{inp("shipping_cost", "Expédition client (€)")}{inp("inbound", "Transport entrant (€)")}
            {inp("markup", "Majoration cible (vide = règle globale)")}{inp("ad_cost", "Coût pub / commande (vide = estimé)")}
            <label className="block"><span className="label-xs">Marché</span>
              <select data-testid="pricing-market" value={f.market} onChange={(e) => setF({ ...f, market: e.target.value })} className={`${ainput} w-full mt-1`}>
                {["CA"].map((m) => <option key={m}>{m}</option>)}
              </select>
            </label>
            <button data-testid="pricing-simulate" onClick={run} className={abtn}>Calculer</button>
          </div>
        </Card>
        <Card title="Résultat" testid="pricing-result">
          {!r ? <div className="text-sm text-slate-500">Lancez une simulation.</div> : (
            <div className="grid md:grid-cols-2 gap-6">
              <div className="text-sm space-y-1">
                {[["Coût rendu", r.cogs], ["Droits", r.duties], ["Frais variables", r.variable_fees], ["Frais fixes", r.fixed_fees], ["Pub", r.ad_cost], ["Prix majoration", r.markup_price], ["Prix plancher", r.floor_price], ["Point mort", r.break_even_price], ["Plafond", r.ceiling_price], ["Prix HT", r.price_ht], ["Prix TTC (EUR)", r.price_ttc]].map(([l, v]) => (
                  <div key={l} className="flex justify-between border-b border-[#1E222D] py-1"><span className="text-slate-400">{l}</span><span className="font-mono">{money(v)}</span></div>
                ))}
                <div className="flex justify-between py-2 text-base"><span>Prix affiché</span><span className="font-mono text-cyan-400" data-testid="pricing-price-local">{money(r.price_local, r.currency)}</span></div>
              </div>
              <div className="space-y-4 font-mono">
                <div><div className="label-xs">Majoration sur coût</div><div className="text-3xl">{pct(r.markup_on_cost)}</div></div>
                <div><div className="label-xs">Marge brute</div><div className="text-3xl">{pct(r.gross_margin)}</div></div>
                <div><div className="label-xs">Marge contributive</div><div className={`text-3xl ${r.viable ? "text-emerald-400" : "text-red-400"}`} data-testid="pricing-cm">{pct(r.contribution_margin)}</div></div>
                <div><div className="label-xs">Contribution nette</div><div className="text-xl">{money(r.contribution)}</div></div>
                <div data-testid="pricing-viable" className={r.viable ? "text-emerald-400" : "text-red-400"}>{r.viable ? "PUBLIABLE" : "NON PUBLIABLE"}</div>
                {r.warnings?.map((w) => <div key={w} className="text-amber-400 text-xs">⚠ {w}</div>)}
              </div>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
